import * as Yup from 'yup';
import checkoutFormModel from './checkoutFormModel';

const {
  formField: {
    firstName,
    email,
    document,
    address1,
    city,
    state,
    zipcode,
    country,
  }
} = checkoutFormModel;

export default [
  // Passo 0 - Dados obrigatórios
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
    [email.name]: Yup.string().email("Email inválido").required(`${email.requiredErrorMsg}`),
    [document.name]: Yup.string().required(`${document.requiredErrorMsg}`),
    [address1.name]: Yup.string().required(`${address1.requiredErrorMsg}`),
    [city.name]: Yup.string().required(`${city.requiredErrorMsg}`),
    [state.name]: Yup.string().required(`${state.requiredErrorMsg}`),
    [zipcode.name]: Yup.string().required(`${zipcode.requiredErrorMsg}`),
  }),

  // Passo 1 - Sem validação (personalizar)
  Yup.object().shape({}),

  // Passo 2 - Sem validação (revisar)
  Yup.object().shape({}),
];